import moment from 'moment';
import { Link } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Avatar, Paragraph, tokens } from '@treams/treams-ui';

const EngagementReplyContainer = styled(Flex)`
	margin-bottom: 20px;
`;

const EngagementReplyContent = styled(Box)`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	flex-shrink: 1;
	align-items: flex-start;
`;

const EngagementReplyText = styled(Paragraph)`
	padding: 8px 12px;
	border-radius: 8px;
	background: ${(props) => props.theme.colors.lightBlueLight};
	color: ${tokens.text.primary};
`;

const ReplyHeader = styled(Flex)`
	align-self: stretch;
`;

const SenderLabel = styled(Paragraph)`
	color: ${tokens.text.primary};
	font-weight: bold;
`;

export function EngagementReply(props: {
	reply: graphql.EngagementReply;
	anonymousUser: graphql.User;
}) {
	const sender = props.reply.sender ?? props.anonymousUser;

	return (
		<EngagementReplyContainer>
			<Box flexGrow={0} flexShrink={0}>
				<Link to={sender.id && `/users/${sender.id}`}>
					<Avatar user={sender} size={32} />
				</Link>
			</Box>
			<EngagementReplyContent ml={2}>
				<ReplyHeader mb={2} ml={2}>
					<SenderLabel flexGrow={1} flexShrink={1}>
						<Link to={sender.id && `/users/${sender.id}`}>
							{sender.firstName} {sender.lastName}
						</Link>
					</SenderLabel>
					<Paragraph flexGrow={0} flexShrink={0} ml={2}>
						{moment(props.reply.createdAt).format('LLL')}
					</Paragraph>
				</ReplyHeader>
				<EngagementReplyText flexShrink={1}>{props.reply.text}</EngagementReplyText>
			</EngagementReplyContent>
		</EngagementReplyContainer>
	);
}
